export const loadTeacherNames = async () => {
  try {
    const response = await fetch('/names.csv');
    const text = await response.text();

    // Parse CSV
    const lines = text.trim().split('\n');
    const teachers = [];

    // Skip header (first line)
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue; // Skip empty lines

      const parts = line.split(',');
      const name = parts[0]?.trim();
      const isDual = parts[1]?.trim() === '1' ? true : false;

      if (name) {
        teachers.push({ name, isDual });
      }
    }

    return teachers;
  } catch (error) {
    console.error('Error loading teacher names:', error);
    return [];
  }
};
